import { render } from "./CreateChatRoom.vue?vue&type=template&id=4b67871e"
import script from "./CreateChatRoom.vue?vue&type=script&lang=js"
export * from "./CreateChatRoom.vue?vue&type=script&lang=js"
script.render = render

export default script